import { onBeforeUnmount } from "vue";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

export function usePhotoSwipe() {
  let lightbox = null;

  const init = () => {
    lightbox?.destroy();
    lightbox = new PhotoSwipeLightbox({
      gallery: ".pswp-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
      showHideAnimationType: "zoom",
      secondaryZoomLevel: 1.5,
      wheelToZoom: true,
      bgOpacity: 0.95,
      paddingFn: (viewportSize) => {
        const isMobile = viewportSize.x < 768;
        return {
          top: isMobile ? 24 : 56,
          bottom: isMobile ? 24 : 56,
          left: isMobile ? 12 : 24,
          right: isMobile ? 12 : 24,
        };
      },
    });
    lightbox.init();
  };

  const open = (galleryDomId, index) => {
    const galleryEl = document.getElementById(galleryDomId);
    if (!galleryEl) return;
    if (!lightbox) init();
    lightbox.loadAndOpen(index, { gallery: galleryEl });
  };

  const destroy = () => {
    lightbox?.destroy();
    lightbox = null;
  };

  onBeforeUnmount(destroy);

  return { init, open };
}
